let fetch = `
const fetch = require('node-fetch');

let url = ;

let options = {
  method: 'POST',
  headers: {'Content-Type': 'application/json', 'X-Secret-Key': ''},
  body: '{"date_from":"2020-12-01","date_to":"2021-01-02","date_type":"deposit","page":"1","per_page":"100"}'
};

fetch(url, options)
  .then(res => res.json())
  .then(json => console.log(json))
  .catch(err => console.error('error:' + err));
`

export default (options) => {
    const _options = {...options}
    delete _options.url
    fetch = fetch.replace(/let url = /s, `let url = (${JSON.stringify(options.url)});`)
    fetch = fetch.replace(/{.*};/s, JSON.stringify(_options, null, 4))
    return fetch
}